module.exports = __webpack_public_path__ + "static/media/ai_fee.01552984.svg";